module.exports = __webpack_public_path__ + "static/media/Emily Adams Headshot.20a74b62.jpeg";